import { render, staticRenderFns } from "./veJkyReportMy.vue?vue&type=template&id=0fa22d1c&scoped=true"
import script from "./veJkyReportMy.vue?vue&type=script&lang=js"
export * from "./veJkyReportMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa22d1c",
  null
  
)

export default component.exports